// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import axios from "axios";

import { store } from "./store/store";
import PersistProvider from "./store/providers/persist-provider";
import { setProducts } from "./store/slices/product-slice";
import App from "./App";

import "animate.css";
import "swiper/css/bundle";
import "./assets/scss/style.scss";

// If product.json is in /public/data, this path is correct:
const url = `${import.meta.env.BASE_URL}data/product.json`;

// console.log("[BOOT] BASE_URL:", import.meta.env.BASE_URL);
// console.log("[BOOT] Fetching products from:", url);

// axios
//   .get(url)
//   .then((res) => {
//     const data = res?.data;
//     console.log(
//       "[BOOT] Products fetched:",
//       Array.isArray(data) ? data.length : "(not an array)"
//     );
//     if (Array.isArray(data) && data.length) {
//       console.log("[BOOT] First product sample:", data[0]);
//     }
//     store.dispatch(setProducts(data));
//   })
//   .catch((err) => {
//     console.error("[BOOT] Failed to fetch products", {
//       url,
//       status: err?.response?.status,
//       message: err?.message,
//     });
//   });

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PersistProvider>
          <App />
        </PersistProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
